import DetailPurchaseOrderAset from './DetailPurchaseOrderAset';

export default DetailPurchaseOrderAset;
